import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const indexPage = resolve => require(['../page/index/index.vue'], resolve);
const service = resolve => require(['../page/soultion/soultion.vue'], resolve);
const company = resolve => require(['../page/company/company.vue'], resolve);
const buildPlan = resolve => require(['../page/buildPlan/buildPlan.vue'], resolve);
const approach = resolve => require(['../page/approach/approach.vue'], resolve);
const recruit = resolve => require(['../page/recruit/recruit.vue'], resolve);
const contact = resolve => require(['../page/contact/contract.vue'], resolve);


export default new Router({
  routes: [
    //首页
    {
      path: '/',
      name: 'indexPage',
      component: indexPage
    },
    //解决方案
    {
      path: '/service',
      name: 'service',
      component: service
    },
    //会社情報
    {
      path: '/company',
      name: 'company',
      component: company
    },
    //建站方案
    {
      path: '/buildPlan',
      name: 'buildPlan',
      component: buildPlan
    },
    //弊社の取り組み
    {
      path: '/security',
      name: 'security',
      component: approach
    },
    //採用情報
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    },
    //联系我们
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js